import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
//import {ref,onUnmounted} from 'vue';
import { getAuth} from 'firebase/auth'
import { getFirestore } from "firebase/firestore"
import "firebase/compat/storage"
const firebaseConfig = {
    apiKey: "AIzaSyAsZXAXd82e9JgnUagIQ9lR3f6pih8H20o",
    authDomain: "resin-database.firebaseapp.com",
    projectId: "resin-database",
    storageBucket: "resin-database.appspot.com",
    messagingSenderId: "203299804773",
    appId: "1:203299804773:web:74edb9780e7f7dc0d5d88c"
  };
  firebase.initializeApp(firebaseConfig)
  export const db=getFirestore()

  export const auth =getAuth()
   const storage =firebase.storage()
   export default storage
  
  
 

